import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { merchandisingMediaShape, resolutionPropType } from "app/utils/propTypes";
import MediaArticle from "app/pages/Merchandising/Media/MediaArticle";
import MediaCarousel from "app/pages/Merchandising/Media/MediaCarousel";
import get from "lodash/get";
import Modal from "react-modal";
import "./MerchandisingMedias.scss";
import MediaArticles from "app/pages/Merchandising/Media/MediaArticles";
import { FormattedMessage } from "react-intl";
import Button from "app/pages/.shared/form/Button";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import { sendTagOnMediaClickMobile, sendTagOnMediaCloseArticle } from "app/utils/analytics";
import { RESOLUTION } from "app/constants";

const MODAL_STYLE = {
	overlay: { zIndex: 10 },
	content: {
		position: "fixed",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		padding: 0,
		zIndex: 10,
	},
};

const MerchandisingMedias = ({ articles = [], resolution }) => {
	const firstArticleTitle = articles[0] && articles[0].title;

	const [selectedMediaTitle, setSelectedMediaTitle] = useState(firstArticleTitle);

	const [isMediaListOpen, setMediaListOpen] = useState(false);

	const selectedMedia = articles.find(article => article.title === selectedMediaTitle);

	const closeModal = useCallback(() => {
		setMediaListOpen(false);
		sendTagOnMediaCloseArticle();
	}, []);

	const openModal = useCallback(() => {
		if (resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL) {
			setMediaListOpen(true);
			sendTagOnMediaClickMobile();
		}
	}, [resolution]);

	return (
		<div className="merchandising-medias">
			{selectedMedia && (
				<div className="merchandising-medias__article">
					<MediaArticle
						onMediaClick={openModal}
						photoUrl={selectedMedia.image}
						title={selectedMedia.title}
						photoThumbnail={selectedMedia.thumbnail}
						descriptions={selectedMedia.description}
						videoType={get(selectedMedia, "video.videoType")}
						videoUrl={get(selectedMedia, "video.url")}
						videoPreviewUrl={get(selectedMedia, "video.previewUrl")}
						videoThumbnail={get(selectedMedia, "video.thumbnail")}
						author={selectedMedia.copyright}
					/>
				</div>
			)}
			<div className="merchandising-medias__caroussel">
				<MediaCarousel
					mediaList={articles}
					onMediaClick={openModal}
					onCarouselMediaClick={setSelectedMediaTitle}
					resolution={resolution}
				/>
			</div>
			<div className="merchandising-medias__cta">
				<Button submit={false} onClick={openModal}>
					<FormattedMessage id="merchandising.media.cta.learn.more.text" />
					<IconRight height={10} width={10} style={{ marginLeft: 10 }} />
				</Button>
			</div>
			<Modal isOpen={isMediaListOpen} style={MODAL_STYLE}>
				<MediaArticles
					mediaList={articles}
					onClose={closeModal}
					style={MODAL_STYLE}
					title={firstArticleTitle}
				/>
			</Modal>
		</div>
	);
};

MerchandisingMedias.propTypes = {
	articles: PropTypes.arrayOf(merchandisingMediaShape),
	resolution: resolutionPropType,
};

export default MerchandisingMedias;
